/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Time_Crystal_DescriptionInputs */

const en_time_crystal_description = /** @type {(inputs: Time_Crystal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First-purchase bonus: get an equal amount of extra Time Crystals. Once per item.`)
};

const ar_time_crystal_description = /** @type {(inputs: Time_Crystal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مكافأة الشراء الأول: احصل على كمية إضافية من بلورة الزمن تساوي الكمية التي تشتريها. مرة واحدة لكل منتج.`)
};

const de_time_crystal_description = /** @type {(inputs: Time_Crystal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstkaufbonus: Du erhältst die gleiche Menge Time Crystals zusätzlich. Einmal pro Artikel.`)
};

const es_time_crystal_description = /** @type {(inputs: Time_Crystal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonificación por primera compra: recibe la misma cantidad de cristales de tiempo adicionales. Una vez por artículo.`)
};

const fr_time_crystal_description = /** @type {(inputs: Time_Crystal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonus de premier achat : recevez autant de Cristaux de temps en bonus que vous en achetez. Une fois par article.`)
};

const it_time_crystal_description = /** @type {(inputs: Time_Crystal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonus per il primo acquisto: ricevi la stessa quantità di Cristalli del Tempo in regalo. Una volta per articolo.`)
};

const ja_time_crystal_description = /** @type {(inputs: Time_Crystal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初回購入ボーナスとして同数の時の結晶をプレゼント。各商品につき1回限り。`)
};

const ko_time_crystal_description = /** @type {(inputs: Time_Crystal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`첫 구매 보너스로 같은 수량의 타임 크리스탈을 추가로 받아요. 상품마다 한 번씩 제공돼요.`)
};

const pt_br_time_crystal_description = /** @type {(inputs: Time_Crystal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bônus de primeira compra: receba a mesma quantidade de Cristais do Tempo extras. Uma vez por item.`)
};

const ru_time_crystal_description = /** @type {(inputs: Time_Crystal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бонус за первую покупку: получите столько же Кристального Времени в подарок. Один раз для каждого товара.`)
};

const th_time_crystal_description = /** @type {(inputs: Time_Crystal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โบนัสการซื้อครั้งแรก: รับคริสตัลแห่งกาลเวลาเพิ่มเท่ากับจำนวนที่ซื้อ รับได้หนึ่งครั้งต่อสินค้าแต่ละรายการ`)
};

const tr_time_crystal_description = /** @type {(inputs: Time_Crystal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk satın alma bonusu: eşit miktarda ek Zaman Kristalleri kazan. Her ürün için bir kez geçerlidir.`)
};

const zh_cn_time_crystal_description = /** @type {(inputs: Time_Crystal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首购加赠等量时光宝石，每个商品限一次。`)
};

const zh_tw_time_crystal_description = /** @type {(inputs: Time_Crystal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首購加贈等量時光寶石，每個商品限一次。`)
};

/**
* | output |
* | --- |
* | "First-purchase bonus: get an equal amount of extra Time Crystals. Once per item." |
*
* @param {Time_Crystal_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const time_crystal_description = /** @type {((inputs?: Time_Crystal_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Time_Crystal_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_time_crystal_description(inputs)
	if (locale === "ar") return ar_time_crystal_description(inputs)
	if (locale === "de") return de_time_crystal_description(inputs)
	if (locale === "es") return es_time_crystal_description(inputs)
	if (locale === "fr") return fr_time_crystal_description(inputs)
	if (locale === "it") return it_time_crystal_description(inputs)
	if (locale === "ja") return ja_time_crystal_description(inputs)
	if (locale === "ko") return ko_time_crystal_description(inputs)
	if (locale === "pt_br") return pt_br_time_crystal_description(inputs)
	if (locale === "ru") return ru_time_crystal_description(inputs)
	if (locale === "th") return th_time_crystal_description(inputs)
	if (locale === "tr") return tr_time_crystal_description(inputs)
	if (locale === "zh_cn") return zh_cn_time_crystal_description(inputs)
	return zh_tw_time_crystal_description(inputs)
});